import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-gdo-shared-components',
    templateUrl: './gdo-shared-components.component.html',
    styleUrls: ['./gdo-shared-components.component.scss'],
    standalone: false
})
export class GdoSharedComponentsComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
